<template>
  <SelectComponent
    v-model="selectedValues"
    :values="assignmentStatuses"
    :label="$t('attributes.status')"
    :required="required"
    name="assignment_status"
    :errors="errors"
    :edition-mode="editionMode"
    colored
  />
</template>

<script>
import { mapGetters } from 'vuex'
import { computed } from 'vue'
import SelectComponent from '@c/BaseFormComponent/SelectComponent'

export default {
  name: 'SelectAssignmentStatus',
  components: { SelectComponent },
  props: {
    editionMode: {
      type: Boolean,
      required: true
    },
    errors: {
      type: Array,
      required: false,
      default: () => []
    },
    modelValue: {
      type: [Array, Number, String],
      required: true
    },
    required: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  emits: ['update:modelValue'],
  setup(props, { emit }) {
    const selectedValues = computed({
      get: () => props.modelValue,
      set: (value) => emit('update:modelValue', value)
    })
    return { selectedValues }
  },
  computed: {
    ...mapGetters({
      assignmentStatuses: 'metadata/getAssignmentStatusMetadata'
    })
  }
}
</script>
